import React,{ forwardRef } from 'react';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';


const CustomTextField = styled(TextField)({
  '& .MuiInputBase-root:before, & .MuiInputBase-root.Mui-disabled:before': {
      border: 'none', 
      borderBottomStyle:"none"
  },

  // Will not be necessary once we remove materialize
  '& .MuiInput-underline:before': {
    borderBottom: 'none', // Remove bottom border
  },
  '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
    borderBottom: 'none', // Remove bottom border on hover
  },
  '& .MuiInput-underline:after': {
    borderBottom: 'none', // Remove bottom border on focus
  },

  //In seperate sections to show that eventually they should look different
  // '& .MuiInputBase-root:hover:before,': {
  //     border: 'none', // To customize once materialize is removed
  //     borderBottomStyle:"none"
  // },
  // '& .MuiInputBase-root::after': {
  //     border: 'none', // To customize once materialize is removed
  //     borderBottomStyle:"none"
  // },

  //Fix to use materialize color scheme until its removed
  '& .MuiInputLabel-root': {
    '&.Mui-focused': {
      color: '#26a69a',
    },
  },
  //COpy de la config de materalize pour pouvoir la modifier
  'input[type=text]:not(.browser-default):focus:not([readonly])':{
    borderBottom: "1px solid #26a69a",
    boxShadow: '0 1px 0 0 #26a69a'
  },
  
  'input[type=text]:not(.browser-default):hover:not([readonly]):not(:focus)':{
    borderColor:"black"
  },
});


const MuiTextField = ({ label, value, onChange = ()=>{}, ...props }) => {

  return (
    <CustomTextField
      label={label}
      value={value}
      onChange={(e)=>onChange(e.target.value)}
      fullWidth
      variant="standard"
      {...props}
    />
  );
};

export default MuiTextField;